import { IConfigureAdditionalFields } from '@shared/interfaces';

/**
 * Returns true when every provided criterion matches a configured additional field.
 * Fields without a matching additional field entry are not excluded (same as public API logic).
 */
export const fieldMatchesAdditionalFields = (
  field: { additional_fields?: IConfigureAdditionalFields[] },
  criteria: Record<string, string | undefined>
): boolean => {
  return Object.entries(criteria).every(([key, expectedValue]) => {
    if (expectedValue === undefined || expectedValue === null) {
      return true;
    }

    const additionalField = field.additional_fields?.find(
      (entry) => entry.key === key
    );

    if (!additionalField) {
      return true;
    }

    return (
      additionalField.value?.toUpperCase()?.trim() ===
      expectedValue.toUpperCase().trim()
    );
  });
};
